import {cssToString} from "./util/css.js";
import {colourSchemeMap} from "./util/colours.js";
import {delay, image_upload_handler} from "./util/util.js";
import {registerShortcuts} from "./util/shortcuts.js";

const config = {
    menubar: false,
    selector: 'textarea',
    plugins: [
        'lists', 'table', 'codemirror', 'codesample', 'link', 'image', 'paste', 'content', 'autolink', 'autoresize', 'emoticons', 'directionality',
    ],
    skin: false,
    body_class: 'sp-editor-content' + ($('html').hasClass('sp-theme-dark') ? ' sp-theme-dark' : ''),
    content_style: ':root {' + cssToString(spCssVarThemes['light']) + '} .sp-theme-dark {' + cssToString(spCssVarThemes['dark']) + '}',
    content_css: laroute.asset('resources/assets/libs/tinymce/css/tinymce-editor' + (App.env === 'production' ? '.min.css' : '.css')),
    // Word paste settings
    // Alias of https://www.tiny.cloud/docs/plugins/opensource/paste/#paste_retain_style_properties
    paste_retain_word_style_properties: 'background color font-family font-size text-align padding',
    // https://www.tiny.cloud/docs/plugins/opensource/autoresize/#min_height
    resize: false,
    min_height: 200,
    autoresize_bottom_margin: 0,
    // Open links in a new tab
    // https://www.tiny.cloud/docs-4x/plugins/link/?_ga=2.260037772.769829965.1642594724-447489908.1642594724#default_link_target
    link_default_target: "_blank",
    link_title: false,
    link_context_toolbar: true,
    // Do not manipulate input URLs
    // https://www.tiny.cloud/docs/configure/url-handling/#relative_urls
    relative_urls : false,
    convert_urls: false,
    // Empty paragraphs are padded with a non-breaking space
    // https://www.tiny.cloud/docs/configure/content-filtering/#extended_valid_elements
    extended_valid_elements: 'data[contenteditable=false|class|value],#p[style|dir<ltr?rtl]',
    // Styles toolbar configuration
    // https://www.tiny.cloud/docs-4x/configure/content-formatting/#style_formats
    style_formats: [
        {title: Lang.get('core.paragraph'), block: 'p'},
        {title: Lang.get('core.heading1'), block: 'h1'},
        {title: Lang.get('core.heading2'), block: 'h2'},
        {title: Lang.get('core.heading3'), block: 'h3'},
        {title: Lang.get('core.heading4'), block: 'h4'},
        {title: Lang.get('core.heading5'), block: 'h5'},
        {title: Lang.get('core.heading6'), block: 'h6'}
    ],
    toolbar: "codemirror | styles formatgroup | listsgroup table link image",
    toolbar_groups: {
        formatgroup: {
            // see https://www.tiny.cloud/docs/advanced/editor-icon-identifiers/ for icons
            icon: 'text-color',
            tooltip: Lang.get('core.more_formatting'),
            items: 'bold underline italic strikethrough | forecolor backcolor | blockquote codesample | ltr rtl | removeformat'
        },
        listsgroup: {
            icon: 'unordered-list',
            tooltip: Lang.get('core.lists'),
            items: 'bullist numlist | indent outdent'
        }
    },
    // https://www.tiny.cloud/docs/tinymce/6/statusbar-configuration-options/#branding
    branding: false,
    // https://www.tiny.cloud/docs/configure/spelling/#browser_spellcheck
    browser_spellcheck: true,
    // https://www.tiny.cloud/docs/plugins/opensource/emoticons/#emoticons_database_url
    emoticons_database_url: laroute.asset("resources/assets/libs/tinymce/emojis.min.js"),
    // https://www.tiny.cloud/docs/configure/content-appearance/#color_map
    color_map: colourSchemeMap(),
    color_cols: 9,
    // https://www.tiny.cloud/docs/ui-components/contextmenu/
    // If enabled, consider that browser_spellcheck requires use of CTRL+Right Click
    // (https://www.tiny.cloud/blog/tinymce-spellchecker/).
    contextmenu: false,
    // https://www.tiny.cloud/docs/tinymce/latest/content-appearance/#highlight_on_focus
    highlight_on_focus: true,
    // https://www.tiny.cloud/docs/general-configuration-guide/upload-images/
    images_upload_handler: image_upload_handler,
    image_dimensions: false,
    // https://www.tiny.cloud/docs/mobile/#mobiledefaultsforselectedsettings
    // Override default mobile settings.
    mobile: {
        toolbar_mode: 'floating',
    },
    // https://www.tiny.cloud/docs/tinymce/latest/table-options/
    table_default_attributes: {},
    table_default_styles: {
        'border-color': '#777',
        'border-collapse': 'collapse',
        'border-style': 'solid',
        'border-width': '1px',
        'width': '100%',
    },
    table_border_styles: [
        {title: Lang.get('core.solid'), value: 'solid'},
        {title: Lang.get('core.dotted'), value: 'dotted'},
        {title: Lang.get('core.dashed'), value: 'dashed'},
        {title: Lang.get('general.none'), value: 'none'},
    ],
    // https://www.tiny.cloud/docs/tinymce/6/security/#securing-embedded-external-resources
    sandbox_iframes: true,
    convert_unsafe_embeds: true,
    // https://www.tiny.cloud/docs/tinymce/6/ui-localization/
    language: 'supportpal',
    language_load: false,
    setup: function (editor) {

        // The editable area is an iframe, so drag events over it never reach the parent document's listeners
        // (e.g. the attachment drop overlay). If a file drag enters the page directly over the editor, re-dispatch
        // it on the parent document. TinyMCE doesn't relay dragenter from the iframe, but dragover fires repeatedly.
        editor.on('dragover', function (e) {
            if (e.dataTransfer && e.dataTransfer.types && e.dataTransfer.types.includes('Files')) {
                $(document.documentElement).trigger($.Event('dragenter', { originalEvent: e }));
            }
        });

        // Toggle expandable quoted sections.
        editor.on('click', function (e) {
            if ($(e.target).is('div.expandable')) {
                // Make sure to remove display property from the element when hiding it, so it doesn't impact emails.
                $(e.target).next().css('display', $(e.target).next().css('display') === 'block' ? '' : 'block');
                editor.execCommand('mceAutoResize');
            }
        });

        // https://www.tiny.cloud/docs/advanced/events/
        editor.on('keyup', function (e) {
            let textarea = editor.getElement(),
              $form = $(textarea).parents('form.validate'),
              validator = $form.data('validator');

            // jquery-validation hasn't been initialised on this form.
            if (! validator) {
                return;
            }

            // 8  = backspace
            // 46 = forward backspace or delete
            if (typeof e.keyCode !== 'undefined' && e.keyCode !== 8 && e.keyCode !== 46) {
                // Wait 1 second for the user to stop typing before checking if the textarea contents is valid. Otherwise,
                // if jquery.validate is using remote (AJAX) rules then this can fire an AJAX for every single key press.
                // The element function will only validate this single element rather than whole form.
                delay(function () {
                    validator.element(textarea);
                }, 1000);
            }
        });

        // https://www.tiny.cloud/docs/api/tinymce.editor.ui/tinymce.editor.ui.registry/#addicon
        editor.ui.registry.addIcon('brackets-curly', '<svg height="24" width="24"><path d="M 6.098 7.104 C 6.298 8.404 6.498 8.704 6.498 10.004 C 6.498 10.804 4.998 11.504 4.998 11.504 L 4.998 12.504 C 4.998 12.504 6.498 13.204 6.498 14.004 C 6.498 15.304 6.298 15.604 6.098 16.904 C 5.798 19.004 6.898 20.004 7.898 20.004 C 8.898 20.004 9.998 20.004 9.998 20.004 L 9.998 18.004 C 9.998 18.004 8.198 18.204 8.198 17.004 C 8.198 16.104 8.398 16.104 8.598 14.104 C 8.698 13.204 8.098 12.504 7.498 12.004 C 8.098 11.504 8.698 10.904 8.598 10.004 C 8.298 8.004 8.198 8.004 8.198 7.104 C 8.198 5.904 9.998 6.004 9.998 6.004 L 9.998 4.004 C 9.998 4.004 8.998 4.004 7.898 4.004 C 6.798 4.004 5.798 5.004 6.098 7.104 Z"></path><path d="M 17.898 7.104 C 17.698 8.404 17.498 8.704 17.498 10.004 C 17.498 10.804 18.998 11.504 18.998 11.504 L 18.998 12.504 C 18.998 12.504 17.498 13.204 17.498 14.004 C 17.498 15.304 17.698 15.604 17.898 16.904 C 18.198 19.004 17.098 20.004 16.098 20.004 C 15.098 20.004 13.998 20.004 13.998 20.004 L 13.998 18.004 C 13.998 18.004 15.798 18.204 15.798 17.004 C 15.798 16.104 15.598 16.104 15.398 14.104 C 15.298 13.204 15.898 12.504 16.498 12.004 C 15.898 11.504 15.298 10.904 15.398 10.004 C 15.598 8.004 15.798 8.004 15.798 7.104 C 15.798 5.904 13.998 6.004 13.998 6.004 L 13.998 4.004 C 13.998 4.004 14.998 4.004 16.098 4.004 C 17.198 4.004 18.198 5.004 17.898 7.104 Z"></path></svg>');

        // https://www.tiny.cloud/docs/advanced/keyboard-shortcuts/
        registerShortcuts(editor);
    }
};

export {config};
